/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentStatsDto } from '../../models/document-stats-dto';
import { DocumentStatsResponseDto } from '../../models/document-stats-response-dto';

export interface DocumentsControllerGetDocumentStats$Params {
      body: DocumentStatsDto
}

export function documentsControllerGetDocumentStats(http: HttpClient, rootUrl: string, params: DocumentsControllerGetDocumentStats$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentStatsResponseDto>> {
  const rb = new RequestBuilder(rootUrl, documentsControllerGetDocumentStats.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentStatsResponseDto>;
    })
  );
}

documentsControllerGetDocumentStats.PATH = '/thalea-documents/documents/stats';
